const hasSafeaPermission = (aliasPermission, store) => {
  if (!aliasPermission) {
    return true;
  }

  const features = store.state._core.application.feature;

  if (typeof aliasPermission === 'string' || aliasPermission instanceof String) {
    const hasPermission = features.find(item => {
      return item.alias === aliasPermission;
    });

    return !!hasPermission;

  } else if (aliasPermission instanceof Array) {
    let haveAtLeastOnePermission = false;

    aliasPermission.forEach(val => {
      const hasPermission = features.find(item => {
        return item.alias === val;
      });

      if (hasPermission) {
        haveAtLeastOnePermission = true;
      }
    });

    return haveAtLeastOnePermission;
  }
};

const validatePage = (features, route) => {
  let isValid = true;

  for (const matchedRoute of route.matched) {
    const path = matchedRoute.path.replaceAll('?', '').replace(/\/$/, '');
    isValid = isValid && features.some(item => {
      return item.endpoint === path || item.webRoute === path;
    });
  }
  return isValid;
};

/**
 * SafeA V3 permission validate
 *
 * @param {string[]} requestedPermissions
 * @param {string[]} userPermissions
 */
const validateHasPermissions = (requestedPermissions, userPermissions) => {
  if (Array.isArray(requestedPermissions) && requestedPermissions.length === 0) {
    return true;
  }

  return requestedPermissions.some(requested => {
    const { aud, permissions } = requested ?? {};
    if (!aud || !permissions) {
      throw new Error(`[Cockpit] Requested permissions must have an aud and permissions property, received "${requested}"`);
    }

    return userPermissions[aud]
      && userPermissions[aud].some(permission => permissions.includes(permission));
  });
};

export {
  validateHasPermissions,
  hasSafeaPermission,
  validatePage
};
